import React, { ReactElement } from 'react';
import { styles } from './PremiumDeliveryMoreInfoPopout.css';
import { TruckPremiumDeliveryIllustrated } from '@jbhi-fi/lanyard-ui/components/Icons';
import FeaturedListItem from '@jbhi-fi/lanyard-ui/components/FeaturedListItem';
import Tick from '@jbhi-fi/lanyard-ui/components/Icons/Tick';
import Error from '@jbhi-fi/lanyard-ui/components/Icons/Error';
import { classNames } from '@jbhi-fi/lanyard-ui/global/utils';
import { PremiumDeliveryFeature } from '@jbhi-fi/utils/src/premiumDelivery/premiumDelivery';
import { palette } from '@jbhi-fi/lanyard-ui/themes';

export const DEFAULT_PREMIUM_DELIVERY_MORE_INFO_HEADING = 'Deliver and unpack';
export const DEFAULT_PREMIUM_DELIVERY_MORE_INFO_PREMIUM_HEADING = 'Deliver, unpack and remove';
export const DEFAULT_PREMIUM_DELIVERY_TERMS_LABEL = 'Home delivery terms and conditions';
export const DEFAULT_PREMIUM_DELIVERY_TERMS_HREF = 'https://support.jbhifi.com.au/hc/en-au/articles/360053720893';

export type PremiumDeliveryMoreInfoPopoutProps = {
  featureTypes?: Array<string>;
  features?: Array<PremiumDeliveryFeature>;
  excludedFeaturesTypes?: Array<string>;
};

const FeaturedList: React.FC<{
  features: Array<PremiumDeliveryFeature> | undefined;
  icon: ReactElement;
}> = ({ features, icon }) => {
  return (
    <>
      {features?.map((feature, i) => {
        return <FeaturedListItem key={i} heading={feature.heading} subText={feature.content} icon={icon} />;
      })}
    </>
  );
};

export const PremiumDeliveryMoreInfoPopout: React.FC<PremiumDeliveryMoreInfoPopoutProps> = ({
  featureTypes,
  features,
  excludedFeaturesTypes,
}) => {
  return (
    <div className={styles.premiumDeliveryMoreInfoPopout}>
      <span className={styles.premiumDeliveryIcon}>
        <TruckPremiumDeliveryIllustrated height="80px" width="167px" />
      </span>
      {featureTypes?.map((featureType, i) => {
        return (
          <div key={i} className={styles.featuresList}>
            <h3 className={styles.heading}>{featureType}</h3>
            <FeaturedList
              features={features?.filter((feature: any) =>
                feature?.experiences?.includes(featureType.toLocaleLowerCase())
              )}
              icon={<Tick color={palette.success.main} />}
            />
          </div>
        );
      })}

      <div className={classNames([styles.featuresList, styles.notesSection])}>
        <h3 className={styles.heading}>Things to note</h3>
        {excludedFeaturesTypes?.map((featureType, i) => {
          return (
            <div key={i} className={styles.featuresList}>
              <h3 className={styles.excludedHeading}>{featureType}</h3>
              <FeaturedList
                features={features?.filter(
                  (feature: any) => feature?.experiences?.length === 0 && !featureTypes?.includes(featureType)
                )}
                icon={<Error color={palette.error.main} />}
              />
            </div>
          );
        })}
        <h3 className={styles.excludedHeading}>Delivery</h3>
        Additional delivery fees may apply if difficult site conditions exist or site conditions are significantly
        different to those described to us when planning your delivery.
        <br />
        <br />
        We may need to make alternative delivery arrangements if, upon arrival at your premises, site conditions would
        make the delivery and or connection of your goods unsafe or hazardous.
        <br />
        <br />
        <span>
          For more information please see the full{' '}
          <a
            className={styles.termsLink}
            target="_blank"
            rel="noreferrer"
            href={window.Jbhifi.premiumDeliveryConfig?.termsHref ?? DEFAULT_PREMIUM_DELIVERY_TERMS_HREF}
          >
            home delivery terms and conditions.
          </a>
        </span>
      </div>
    </div>
  );
};
